import axios from "axios";
import api from "../api/axios";
import { ENDPOINTS } from "../api/endpoints";

/**
 * Realiza generacion de migracion
 *
 * @param body Parámetros para la migración
 * @param headers Headers requeridos para la solicitud
 * @returns Respuesta de la migración
 */
export async function migrateGenerate(migrationId: string, xAccountId: string, appis: []) {
  try {
    const requestHeaders = {
      "X-ACCOUNT-ID": xAccountId,
      "X-RESPONSE-FORMAT": "zip",
      "X-AI-MODEL": "gemini",
    };

    const body = {
      migrationId: migrationId,
      appis: appis,
    };
    const responseMigrateGenerate = await api
      .post(ENDPOINTS.MIGRATE.CREATE, body, {
        headers: requestHeaders,
      })
      .then((res) => {
        return res.data;
      });

    return responseMigrateGenerate;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorData = error.response?.data;
      return {
        success: false,
        status: error.response?.status || 500,
        error:
          errorData?.detail ||
          (errorData?.content && typeof errorData.content === "object"
            ? JSON.stringify(errorData.content)
            : errorData?.content) ||
          errorData?.message ||
          "Ocurrió un error durante la migración",
        content: errorData?.content || undefined,
        comments: [], // Añadir esta propiedad para satisfacer el tipo MigrationResponse
      };
    }

    return {
      success: false,
      status: 500,
      error: error instanceof Error ? error.message : "Ocurrió un error inesperado",
    };
  }
}
